'use client';

import styled, { css } from 'styled-components';

import { colors } from '@/styles/theme';

export const Container = styled.button`
  display: flex;
  justify-content: ${({ $justify }) => $justify || 'center'};
  align-items: center;

  justify-self: ${({ $justifySelf }) => $justifySelf || 'flex-start'};
  align-self: ${({ $alignSelf }) => $alignSelf || 'flex-start'};

  padding: 10px 16px;
  gap: 16px;
  height: 40px;
  width: ${({ $width }) => $width || 'fit-content'};

  font-weight: 600;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-radius: 8px;
  border: 1px solid ${({ $color }) => colors[$color] || colors.gray4};
  color: ${({ $color }) => colors[$color] || colors.dark};
  background-color: ${({ $background }) => colors[$background] || 'transparent'};
  transition: all 0.2s ease;

  &:hover {
    cursor: pointer;
    background-color: ${colors.gray2};
  }

  &:disabled {
    background-color: ${colors.gray4};
    color: ${colors.gray5};
    border: 1px solid ${colors.gray4};

    &:hover {
      cursor: default;
    }
  }

  ${({ $naked }) =>
    $naked &&
    css`
      height: auto;

      border: none;

      &:hover {
        color: ${colors.dark + 80};
        background-color: transparent;
      }
    `}

  ${({ $outline }) =>
    $outline &&
    css`
      height: auto;

      border: ${({ $color }) => `1px solid ${colors[$color] || colors.gray3}`};

      &:hover {
        border: ${({ $color }) => `1px solid ${colors[$color] || colors.gray4}`};
      }
    `}

  ${({ $filled }) =>
    $filled &&
    css`
      color: ${({ $color }) => colors[$color] || colors.light};
      background-color: ${colors.dark};

      &:hover {
        background-color: ${colors.dark + 99};
      }
    `}
`;
